import React from 'react'

const Title = ({ title, des }) => {
  return (
    <div className="flex flex-col gap-4 font-titleFont mb-14 overflow-hidden relative">
      {/* أضفنا container إضافي للتحكم في العرض */}
      <div className="w-full overflow-hidden">
        <h3
          className="text-sm uppercase font-light text-designColor tracking-wide over-flow-title"
          style={{
            display: 'inline-block',
            whiteSpace: 'nowrap',
            willChange: 'transform', // تحسين الأداء
            backfaceVisibility: 'hidden', // منع الارتعاش في بعض المتصفحات
          }}
        >
          {title}
        </h3>
      </div>
      <h1 className="text-4xl md:text-5xl text-gray-300 font-bold capitalize pb-4">{des}</h1>
    </div>
  );
}

export default Title